import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { Types as LoaderTypes } from "model/data"

export const { Types, Creators } = createActions("ompnt/modules/analyze-factors-risk", {
  setFactorCategory: {
    props: ["category"],
  },
})

export const DEFAULT_STATE = {
  selectedView: "factorRisk",
  selectedFactorCategory: "factors",
}

function handleLoadSuccess(state, action) {
  if (action.resource === "portfolio") {
    return { ...DEFAULT_STATE }
  }

  return state
}

function handleSetFactorCategory(state, { category }) {
  return {
    ...state,
    selectedFactorCategory: category,
  }
}

export default createReducer(DEFAULT_STATE, {
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [Types.SET_FACTOR_CATEGORY]: handleSetFactorCategory,
})
